export default class Dictionary {
  dictionaries = {};

  constructor (dictionaries) {
    this.dictionaries = dictionaries;
  }

  getBy (dictionary, code, field) {
    if (!this.dictionaries[dictionary] || !this.dictionaries[dictionary][code]) return '';
    if (typeof field === 'undefined') {
      return this.dictionaries[dictionary][code];
    }
    return typeof this.dictionaries[dictionary][code][field] === 'undefined'
      ? code
      : this.dictionaries[dictionary][code][field];
  }
};
